<template>
    <div>
        <div>
            <a-button class="top_btn" type="primary"
                      @click="()=>{visibleForm = true; titleForm='添加字段'; this.editId=''; }" v-has="'btn_add'"  > 添加字段
            </a-button>
        </div>
        <a-table
                :columns="columns"
                :data-source="data"
                :loading="loading"
                rowKey="id"
                :pagination="false"
        >
        <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs"/>
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visibleForm = true; titleForm='修改字段',editId=text.id ; }" v-has="'btn_edit'">编辑 <a-divider type="vertical"/></a>

          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}">
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <PageForm :visible="visibleForm" :title="titleForm" :editId="editId"
                  @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "></PageForm>
    </div>
</template>

<script>
    import PageForm from "./components/pageForm";
    import API from "./api";
    import {changStatus, removeById, orderList} from "../../../utils/utils"

    const columns = [
        {
            title: "id",
            dataIndex: "id",
            key: "id",
            width: "150px",
        },
        {
            title: "字段名称",
            dataIndex: "name",
            ellipsis: true,
            key: "name",
        },
        {
            title: "值",
            key: "value",
            dataIndex: "value",
        },
        {
            title: "添加时间",
            dataIndex: "create_time",
            ellipsis: true,
            key: "create_time",
        },

        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    const data = [];

    export default {
        name: "index",
        data() {
            return {
                loading: true,
                current: 1,
                visibleForm: false,
                titleForm: "",
                editId: null,
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                },
                data: [],
                columns,
                selectedRowKeys: [],
                sortLists: []
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/SiteSettings/PageContent"; //设置左侧导航2-2 active
        },
        components: {PageForm},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        mounted() {
            this.getList()
        },
        methods: {
            getList(page) {
                API.pageContent.GET_LIST(page || 1).then(res => {
                    this.pagination.total = res.data.data.total
                    this.pagination.pageSize = res.data.data.per_page
                    this.pagination.current = res.data.data.current_page
                    this.data = res.data.data
                    this.loading = false
                })
            },
            confirm(row) {
                removeById(API.pageContent.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },

        },
    }
</script>

<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
